import attendanceReport from './components/attendanceReport.vue';


export default {
  routes: [
    {
      path: '/',
      component:attendanceReport,
      name:'attendanceReport'
    },

  ]
};
